import { MergeSourcePlatesDTO, MultiMergePlateQCUpdate, MultiPlateUpdate } from './multiplate-update-dto';
import { environment } from '../../environments/environment';
import {HttpClient, HttpResponse} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Plate } from '../models/plate';
import { CommentDTO, MultiCommentDTO } from '../ma-comments-popup/comment-dto';
import { Sample } from '../models/sample';
import { SampleCommentDTO } from '../models/sampleCommentDTO';
import { map } from 'rxjs/operators';
import { BBResponseContainer } from '../carrier/response-container';
import { WashAndStainArraysListDTO, WashAndStainPrepRequestDTO, WashAndStainPrepUpdateDTO } from '../ma-beadchip-loading-axiom/multiplate-update-dto';
import { CompleteBeadchipAndSourcePlatesDTO } from '../ma-result-evaluation/model/ma-result-evaluation-dtos';
import { PlateWithSampleID } from '../models/plate-with-sample-dto';
import { SampleRedoDownloadDTO } from '../models/sampleRedoDownloadDTO';
import { PlateListDTO } from '../dto/plateListDTO';

@Injectable({
  providedIn: 'root'
})
export class  MaPlatePreparationService {
  PLATE_PREPARATION_API = environment.BB_SAMPLE_PROCESSING_API
  MA_LOGFILES_FUNC_APP_API = environment.BB_MA_LOGFILE_FUNC_APP_API
  SAMPLE_UPDATE_API = environment.BB_MA_DELIVERY_API

  private readonly CONTENT_DISPOSITION = "Content-Disposition";
  private readonly CONTENT_TYPE = "Content-Type";

  constructor(private httpClient: HttpClient) { }

  fetchPlate(plateID: string,labId:string){
    let url = this.PLATE_PREPARATION_API+'plate/'+labId+"/"+plateID;
    return this.httpClient.get<BBResponseContainer>(url).pipe((map(response => response.data as Plate)));
  }

  fetchPlateByWGAPlateId(plateID: string,labId:string){
    let url = this.PLATE_PREPARATION_API+'plateByWGAPlateId/'+labId+"/"+plateID;
    return this.httpClient.get<BBResponseContainer>(url).pipe(map(result => result.data as Plate));
  }

  fetchPlates(plateListDTO: PlateListDTO): Observable<Plate[]>{
    const url = this.PLATE_PREPARATION_API + 'plate';
    return this.httpClient.put<BBResponseContainer>(url, plateListDTO).pipe((map(response => response.data as Plate[])));
  }

  fetchPlateByIDandLab(lab:string, plateID: string){
    let url = this.PLATE_PREPARATION_API+'sampleDetailsByPlateId/'+lab+'/'+plateID;
    return this.httpClient.get<BBResponseContainer>(url).pipe(map(result => result.data as Plate));
  }

  updatePlate(plateID:string,plate:Plate,labId:string,lastUpdatedStep:string = ""): Observable<Plate>{
    let url = this.PLATE_PREPARATION_API+'plate/'+labId+"/"+plateID;
    if(lastUpdatedStep !== ""){
      url = `${url}?lastUpdatedStep=${lastUpdatedStep}`
    }
    return this.httpClient.put<BBResponseContainer>(url,plate).pipe((map(response => response.data as Plate)));
  }

  loadBeadchips(labId: string, loadBeadchip: any): Observable<string>{
    let url = this.PLATE_PREPARATION_API+'loadBeadchip/'+labId;
    return this.httpClient.post<BBResponseContainer>(url, loadBeadchip).pipe(map(result => result.data as string))
  }

  createPlate(plate: Plate): Observable<Plate>{
    let url = this.PLATE_PREPARATION_API+'plate';
    return this.httpClient.post<BBResponseContainer>(url,plate).pipe((map(response => response.data as Plate)));
  }

  fetchPlateBySample(sampleId: string,labId : string, plateType: string = "PLATE"){
    let url = this.PLATE_PREPARATION_API+'plateBySample/'+labId+"/"+sampleId+"?plateType="+plateType;
    return this.httpClient.get<BBResponseContainer>(url).pipe(map(result => result.data as Plate))
  }

  updateOFHReceivedSamples(request: {}){
    let url = this.SAMPLE_UPDATE_API+'updateReceivedSamples';
    return this.httpClient.put<any>(url, request)
  }

  updateOFHCompletedSamples(request: {}){
    let url = this.SAMPLE_UPDATE_API+'completeSamples';
    return this.httpClient.put<any>(url, request);
  }

  updateStartProcessForMultiplePlates(multiPlateUpdate:MultiPlateUpdate){
    let url = this.PLATE_PREPARATION_API+'processStep/startProcess';
    return this.httpClient.put<BBResponseContainer>(url,multiPlateUpdate).pipe(map(result => result.data as string))
  }

  updateEndProcessForMultiplePlates(multiPlateUpdate:MultiPlateUpdate){
    let url = this.PLATE_PREPARATION_API+'processStep/endProcess';
    return this.httpClient.put<BBResponseContainer>(url,multiPlateUpdate).pipe(map(result => result.data as string))
  }

  updateStartActionProcessForMultiplePlates(multiPlateUpdate:MultiPlateUpdate){
    let url = this.PLATE_PREPARATION_API+'processStep/startAction';
    return this.httpClient.put<BBResponseContainer>(url,multiPlateUpdate).pipe(map(result => result.data as string))
  }

  updateQCCheckForMultiplePlates(multiPlateUpdate:MultiPlateUpdate, labid: string){
    let url = this.PLATE_PREPARATION_API+'updateMultiplePlatesQCCheck/'+labid;
    return this.httpClient.put<BBResponseContainer>(url,multiPlateUpdate).pipe(map(result => result.data as string))
  }

  updateQCCheckForMultipleMergePlates(multiPlateUpdate:MultiMergePlateQCUpdate, labid: string){
    let url = this.PLATE_PREPARATION_API+'updateMultipleMergePlatesQCCheck/'+labid;
    return this.httpClient.put<any>(url,multiPlateUpdate);
  }

  processDetailsbyPlateId(lab:string, plateID: string, plateType: string){
    let url = this.PLATE_PREPARATION_API+'processDetailsbyPlateId/'+lab+'/'+plateID+'?platetype='+plateType;
    return this.httpClient.get<BBResponseContainer>(url).pipe(map(result => result.data as Plate))
  }

  commentDetailsbyPlateId(labId : string, plateId: string){
    let url = this.PLATE_PREPARATION_API+'commentDetailsbyPlateId/'+labId+"/"+plateId;
    return this.httpClient.get<BBResponseContainer>(url).pipe((map(result => result.data as Plate)));
  }

  checkDuplicatePlateId(labId: string, plateId: string, type: string){
    let url = this.PLATE_PREPARATION_API+'checkDuplicatePlateId/'+labId+"/"+plateId+"/"+type;
    return this.httpClient.get<BBResponseContainer>(url).pipe((map(result => result.data)))
  }

  logFileUpload(uploadedFileContent, labId: string, puid : string){
    let url = this.MA_LOGFILES_FUNC_APP_API + "api/logfile?labid="+labId+"&puid="+puid;
    return this.httpClient.post<any>(url, uploadedFileContent);
  }

  updateMultiComment(multiCommentDTO:MultiCommentDTO){
    let url = this.PLATE_PREPARATION_API+'updateMultipleComments';
    return this.httpClient.put<BBResponseContainer>(url,multiCommentDTO).pipe(map(result => result.data as string));
  }

  updateComment(commentDTO: CommentDTO){
    let url = this.PLATE_PREPARATION_API+'updatecomments';
    return this.httpClient.put<BBResponseContainer>(url,commentDTO).pipe(map(result => result.data as string))
  }

  fetchSampleDetailsBySampleID(labId: string, sampleId){
    let url = this.PLATE_PREPARATION_API+'sampleDetailsbySampleId/'+labId+'/'+sampleId;
    return this.httpClient.get<BBResponseContainer>(url).pipe(map(result => result.data ));
  }

  addSampleToPlate(labId: string, plateId: string, sample: Sample){
    let url = this.PLATE_PREPARATION_API + 'addSampleToPlate/'+labId+'/'+plateId;
    return this.httpClient.put<BBResponseContainer>(url, sample).pipe((map(response => response.data as Plate)));
  }

  downloadGeneTitanWorkFile(labId: string, plateId: string){
    let url = this.PLATE_PREPARATION_API + 'downloadGeneTitanWorkFile/'+labId+'/'+plateId ;
    return this.httpClient.get(url, { observe: 'response', responseType: 'blob'}).pipe(
      map((res) => {
        return {
          fileContent: new Blob([res.body], { type: res.headers.get('content-Type') }),
          filename: plateId+"_384Chip.xlsx"
        }
      })
    );
  }

  getProcessFlow(processFlowName: string, labId: string): Observable<any> {
    let url = environment.BB_MDMSERVICE_URL + 'processflow/sampletype/'+labId;
    return this.httpClient.post<any>(url,{"processFlowName":processFlowName});
  }

  updateSampleComment(labId: string, sampleId: string, comment: SampleCommentDTO): Observable<BBResponseContainer>{
    let url = environment.BB_MA_DELIVERY_API + "addComment/"+labId+"/"+sampleId;
    return this.httpClient.put<BBResponseContainer>(url,comment);
  }

  getSampleComments(labId: string, sampleId: string): Observable<BBResponseContainer>{
    let url = environment.BB_MA_DELIVERY_API + "sampleComments/"+labId+"/"+sampleId;
    return this.httpClient.get<BBResponseContainer>(url);
  }

  downloadLynxWorkfile(labId: string, sampleVolume:any){
    const url = this.PLATE_PREPARATION_API + 'downloadLynxWorkfile/'+labId;
    return this.httpClient.put(url, { "sampleVolume":sampleVolume },{ responseType:'blob',observe: 'response' }).pipe(
      map((result:HttpResponse<Blob>) => {
        const contentDispositionHeader = result.headers.get(this.CONTENT_DISPOSITION);
        const contentType = result.headers.get(this.CONTENT_TYPE);
        const filename = contentDispositionHeader.split("=")[1];
        return {
          fileContent: new Blob([result.body],{ type:contentType }),
          filename: filename
        }
      })
    );
  }

  uploadLynxWorkfile(formDataFile: FormData):Observable<number>{
    let url = this.PLATE_PREPARATION_API + 'uploadLynxWorkfile';
    return this.httpClient.post<BBResponseContainer>(url,formDataFile).pipe(map(result => result.data as number));
  }

  // Need to update the function
  downloadPrecellWorkfile(labId: string, precellPlateData:any){
    const url = this.PLATE_PREPARATION_API + 'downloadPrecellWorkfile/'+labId;
    return this.httpClient.put(url, { "precellPlateData":precellPlateData },{ responseType: 'blob',observe: 'response' }).pipe(
      map((result:HttpResponse<Blob>) => {
        const contentDispositionHeader = result.headers.get(this.CONTENT_DISPOSITION);
        const contentType = result.headers.get(this.CONTENT_TYPE);
        const filename = contentDispositionHeader.split("=")[1];
        return {
          fileContent: new Blob([result.body], { type: contentType }),
          filename: filename
        }
      })
    );
  }

  // Need to update the function
  uploadPrecellLogfile(formDataFile: FormData, labId: string){
    let url = this.PLATE_PREPARATION_API + 'uploadPrecellLogFile/'+labId;
    return this.httpClient.post<any>(url,formDataFile);
  }

  checkSamplePresentInPlate( labId: string,sampleid: string) {
    let url = this.PLATE_PREPARATION_API+'checkSamplePresent/'+labId+"/"+sampleid;
    return this.httpClient.get<BBResponseContainer>(url).pipe(map(result => result.data));
  }

  updateReProcessedToSample(labId: string, sampleid: string) {
    let url = this.PLATE_PREPARATION_API+'updateReProcessedToSample/'+labId+"/"+sampleid;
    return this.httpClient.put<any>(url, sampleid);
  }

  removeSamples(body){
    let url = this.PLATE_PREPARATION_API + "removeSample";
    return this.httpClient.post<any>(url, body);
  }

  receiptReportDownload(selectedLabId: string, dateSelected: Date, exported: boolean) {
    const url = this.PLATE_PREPARATION_API+'receiptReportDownload';
    const body = {
      labid : selectedLabId,
      dateSelected: dateSelected.toDateString(),
      exported: exported
    }
    return this.httpClient.put(url, body,{ observe:'response', responseType:'blob' }).pipe(
        map((result:HttpResponse<Blob>) => {
          const contentDispositionHeader = result.headers.get(this.CONTENT_DISPOSITION);
          const contentType = result.headers.get(this.CONTENT_TYPE);
          const filename = contentDispositionHeader.split("=")[1];
          return {
            fileContent: new Blob([result.body], { type:contentType }),
            filename: filename
          }
        })
    );
  }

  uploadExcelFileForValidateSamples(formData: FormData) {
    let url = this.PLATE_PREPARATION_API + 'validateSamplesFile';
    return this.httpClient.post<any>(url,formData);
  }

  updateStartProcessForMultipleBeadChips(multiPlateUpdate:MultiPlateUpdate){
    let url = this.PLATE_PREPARATION_API+'/processStep/beadChipStartProcess';
    return this.httpClient.put<BBResponseContainer>(url,multiPlateUpdate).pipe(map(result => result.data as string))
  }

  updateActionForMultipleBeadChips(multiPlateUpdate:MultiPlateUpdate){
    let url = this.PLATE_PREPARATION_API+'/processStep/beadChipStartAction';
    return this.httpClient.put<BBResponseContainer>(url,multiPlateUpdate).pipe(map(result => result.data as string))
  }

  getArraysForWashAndStain(data: WashAndStainPrepRequestDTO){
    let url = this.PLATE_PREPARATION_API+'getArraysForWashAndStain'
    return this.httpClient.put<BBResponseContainer>(url, data).pipe((map(result => result.data as Array<WashAndStainArraysListDTO>)))
  }

  updateWashAndStainForMultipleArrays(data: WashAndStainPrepUpdateDTO){
    let url = this.PLATE_PREPARATION_API+'updateWashAndStainForMultipleArrays'
    return this.httpClient.put<BBResponseContainer>(url,data).pipe(map(result => result.data as string))
  }

  downloadSampleSheet(selectedLabId: string, sourcePlates: string) {
    let url = this.PLATE_PREPARATION_API+'sampleSheetDownload';
    let body = {
      labid : selectedLabId,
      sourcePlates : sourcePlates
    }
    const date = new Date();
    let currentDate = `${date.getDate()}_${date.getMonth()+1}_${date.getFullYear()}`;
    return this.httpClient.put(url, body, { observe: 'response', responseType: 'blob'}).pipe(
      map((res)=>{
        const contentDispositionHeader = res.headers.get(this.CONTENT_DISPOSITION)

        const filename = contentDispositionHeader ?
        contentDispositionHeader.split("=")[1] : `${sourcePlates}_${currentDate}`

        return {
          fileContent: new Blob([res.body],{type:"application/vnd.ms-excel"}),
          filename: filename,
          status:res.status
        }
       })
    )
  }

  downloadMultiSampleSheetZip(labid: string, date) {
    let url = `${this.PLATE_PREPARATION_API}multiSampleSheetDownload?labid=${labid}&date=${date}`

    return this.httpClient
      .get(url, { responseType: "blob", observe: "response" })
      .pipe(
        map((res) => {
          if (res.status === 204) {
            return {
              fileContent: null,
              message: "No plates found for the given date",
              status: res.status,
            }
          }

          const contentDispositionHeader = res.headers.get(this.CONTENT_DISPOSITION)
          const filename = contentDispositionHeader
            ? contentDispositionHeader.split("=")[1]
            : "download.zip"

          return {
            fileContent: new Blob([res.body], { type: "application/zip" }),
            filename: filename,
            status: res.status,
            message: "Success",
          }
        })
      )

  }

  downloadRedoSamplesList(data: SampleRedoDownloadDTO) {
    let url = this.PLATE_PREPARATION_API+"sampleScan/download/redoSamples";
    const date = new Date();
    let currentDate = `${date.getDate()}_${date.getMonth()+1}_${date.getFullYear()}`;
    return this.httpClient.put(url, data, { observe: 'response', responseType: 'blob'}).pipe(
      map((res)=>{
        return {
          fileContent : new Blob([res.body], { type:res.headers.get('content-Type')}),
          filename: `Redo_Samples_List_${currentDate}.xlsx`,
          status:res.status
        }
       })
    )
  }

  getRedoSampleCount(selectedLabId: string) {
    let url = this.PLATE_PREPARATION_API+'sampleScan/count/redoSamples/'+selectedLabId;
    return this.httpClient.get<BBResponseContainer>(url).pipe((map(result => result.data as number)));
  }

  completeBeadchipAndSourcePlates(data: CompleteBeadchipAndSourcePlatesDTO){
    let url = this.PLATE_PREPARATION_API + 'resultEvaluation/completeBeadChips';
    return this.httpClient.put<BBResponseContainer>(url,data).pipe(map(result => result.data as string))
  }

  fetchStoragePlates(selectedLabId: string) {
    let url = this.PLATE_PREPARATION_API+'fetch/storagePlates/'+selectedLabId;
    return this.httpClient.get<BBResponseContainer>(url).pipe((map(result => result.data as Plate[])));
  }

  fetchPlateWithSampleId(labId:string,data:any){
    let url = `${this.PLATE_PREPARATION_API}fetch/plateWithSample/${labId}`
    return this.httpClient.put<BBResponseContainer>(url,data).pipe((map(result => result.data as Array<PlateWithSampleID>)));
  }

  updatePlateProcessflowname(data: any) {
   let url = this.PLATE_PREPARATION_API+'admin/update/plateProcessflow';
   return this.httpClient.put<BBResponseContainer>(url,data).pipe((map(result => result.data)))
  }

  updatePlateSelectedStatus(selectedLabId: string, selectedPlate: any, selectedStatus: string,updatedPlateID:string,puid: string,qcNanoDropConfigured = false) {
    let url = this.PLATE_PREPARATION_API + 'admin/update/plateStatus';
    let data = {
      labid: selectedLabId,
      plate: selectedPlate,
      status: selectedStatus,
      updatedPlateID: updatedPlateID,
      qcNanoDropConfigured:qcNanoDropConfigured,
      puid: puid
    }
    return this.httpClient.put<BBResponseContainer>(url, data).pipe(map(result => result.data))
  }

  updateNewPlateID(selectedLabId: string, duplicatePlateID: string, newPlateID: string) {
    let url = this.PLATE_PREPARATION_API + 'run/update/newPlateID';
    let data = {
      labId: selectedLabId,
      duplicatePlateID: duplicatePlateID,
      newPlateID: newPlateID
    }
    return this.httpClient.put<BBResponseContainer>(url, data).pipe(map(result => result.data as string))
  }

  fetchMergePlateSourcePlates(dto: MergeSourcePlatesDTO): Observable<BBResponseContainer>{
    let url = this.PLATE_PREPARATION_API + 'getMergeSourcePlates';
    return this.httpClient.put<BBResponseContainer>(url, dto);
  }
}
